import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {SelectTableFilter} from "@/components/selectTableFilter/SelectTableFilter.tsx";
import {AuditLogObjectTypeDisplay} from "@/lib/types/auditlogs.ts";

interface AuditLogActionBarProps {
  search: string;
  setSearch: (value: string) => void;
  objectTypeFilter: keyof typeof AuditLogObjectTypeDisplay | null;
  setObjectTypeFilter: (value: keyof typeof AuditLogObjectTypeDisplay | null) => void;
}

export const AuditLogActionBar = ({
  search,
  setSearch,
  objectTypeFilter,
  setObjectTypeFilter,
}: AuditLogActionBarProps) => {
  return (
    <div className="d-flex align-items-center">
      <div className="me-3" style={{minWidth: "17rem"}}>
        <SearchInput value={search} onChange={setSearch} placeholder={"Search by user, object or ID"} />
      </div>
      <div style={{minWidth: "11rem"}}>
        <SelectTableFilter
          enumOptions={AuditLogObjectTypeDisplay}
          onChange={setObjectTypeFilter}
          allOption={"All Object Types"}
          placeholder={"Object Type"}
          isClearable={true}
          isSearchable={true}
          value={objectTypeFilter}
        />
      </div>
    </div>
  );
};
